import { Component, Input, Output, OnInit, EventEmitter, ViewChild, ViewContainerRef, HostListener, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart } from '@angular/router';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { SendMoneyDetail, SendMoneyProgramDetail } from '../../models/sendmoney/sendmoney';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { dashboardlandingpageservice } from '../../_services/dashboardservice/dash-board.service';
import { UserStateService } from '../../_services/userservice/userstateservice';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
import { MyCurrencyPipe,MyCurrencyExchangeRatePipe } from '../../sharedcomponents/_pipe/mycurreny';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-dashboard-supersend',
  templateUrl: './dashboard-supersend.component.html',
  styleUrls: ['./dashboard-supersend.component.css'],
  providers: [dashboardlandingpageservice, MyCurrencyPipe, utilityService,MyCurrencyExchangeRatePipe]
})
export class DashboardSupersendComponent implements ModalComponent<CustomModalContext>, OnInit {
  context: CustomModalContext;
  autoTicks = false;
  disabled = false;
  invert = false;
  max = 4;
  min = 0;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  value = 0;
  vertical = false;
  arrPrograms = [];
  arrProgramsValues = [];
  TodayProgram: any = {};
  CurProgram: any = {};
  model: any = {};
  countrycollection = [];
  RoundingPlaces: number = AppSettings.fractionDigit;
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    private modal: Modal,
    private alertService: AlertService,
    private countryserv: CountryService,
    private sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    private dbService: dashboardlandingpageservice,
    private userStateService: UserStateService,
    public translate: TranslateService,
    private currencyPipe: MyCurrencyPipe,
    private exchangeRatecurrencyPipe: MyCurrencyExchangeRatePipe
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });

    this.context = dialog.context;
    this.context.size = 'sm';
this.model.benificaryName = '';
    this.model.srcAmount = 100;
    this.model.srcAmountIsDisabled = false;
    this.model.fee = 0;
    this.model.destAmount = 0;
    this.model.todayRate = 0;
    this.model.supersendRate = 0;
    this.model.rate = 0;
    this.model.superSendfee = 0;
    this.model.CountryCodeFrom = AppSettings.BaseCountry;
    this.model.CountryCodeTo = AppSettings.BaseCountry;
    this.model.CurrencyCodeFrom = AppSettings.BaseCountryCurrency;
    this.model.CurrencyCodeTo = AppSettings.BaseCountryCurrency;
    this.countrycollection = this.countryserv.getCountryListFromLocale();
    // this.userStateService.getcurrentUserDetailData().subscribe(data => {
    //   this.model.CountryCodeTo = data.countryPreference;
    // });

    this.model.srcAmountBase = this.dialog.context.modalData.srcAmount;
    this.model.srcAmount = this.dialog.context.modalData.srcAmount;
    this.model.srcAmountIsDisabled = this.dialog.context.modalData.srcAmountIsDisabled;
    this.model.page = this.dialog.context.modalData.page;
    this.model.LocationId = this.dialog.context.modalData.LocationId;
    this.model.DeliveryMethod = this.dialog.context.modalData.DeliveryMethod;
    this.model.CountrySupportedCurrencyCodesTo = this.dialog.context.modalData.CountrySupportedCurrencyCodesTo;
    this.model.ProgramId = this.dialog.context.modalData.ProgramId != undefined || '' ? this.dialog.context.modalData.ProgramId : 0;
    this.model.CountryCodeTo = this.dialog.context.modalData.CountryCodeTo;
    this.model.benificaryName =  this.utilityServ.getObjectText(this.dialog.context.modalData.beneficiary.FirstName) + ' ' + this.utilityServ.getObjectText(this.dialog.context.modalData.beneficiary.LastName);

    const _self = this;
    this.model.CurrencyCodeTo = this.utilityServ
      .getArray(this.countrycollection.filter(item => item.CountryCode === _self.model.CountryCodeTo)[0].CountryCurrencyCode)
      .filter(item => item.CountryCurrencyCode !== AppSettings.BaseCountryCurrency)[0].CurrencyCode;
    if (this.model.CurrencyCodeTo == 'USD') {
      this.model.CurrencyCodeTo = '';
    }

    // this.getProgramDetails();
    this.arrPrograms = this.dialog.context.modalData.arrPrograms;
    this.max = this.dialog.context.modalData.max;
    this.getSuperSendDetails();
  }

  ngOnInit() {
    this.model.srcAmount = this.currencyPipe.transformEx(this.model.srcAmount, this.model.CurrencyCodeFrom);
  }

  private _tickInterval = 1;
  get tickInterval(): number | 'auto' {
    return this.showTicks ? (this.autoTicks ? 'auto' : this._tickInterval) : 0;
  }
  set tickInterval(v) {
    this._tickInterval = Number(v);
  }

  getSuperSendDetails() {

    const _self = this;
    let reqObj: any = {};
    reqObj.programs = this.arrPrograms;
    reqObj.Amount = parseFloat(this.currencyPipe.parse(this.model.srcAmount)); //this.model.srcAmount;
    reqObj.CountryCodeFrom = this.model.CountryCodeFrom;
    reqObj.CountryCodeTo = this.model.CountryCodeTo;
    reqObj.CurrencyCodeFrom = this.model.CurrencyCodeFrom;
    reqObj.CurrencyCodeTo = this.model.CurrencyCodeTo;
    reqObj.page = this.model.page;
    reqObj.LocationId = this.model.LocationId;
    reqObj.DeliveryMethod = this.model.DeliveryMethod;
    reqObj.CountrySupportedCurrencyCodesTo = this.model.CountrySupportedCurrencyCodesTo;
    this.utilityServ.busy = this.dbService.GetSuperSend(reqObj).subscribe(
      data => {
        if (data.StatusCode == 20001) {
          return false;
        }
        if (data.StatusCode == 10000) {
          this.arrProgramsValues = data.SuperSends;
          ////console.log("array problema ", this.arrProgramsValues)
          // let obj: any = {};
          // obj.value = this.model.ProgramId;
          // let program = this.arrPrograms[obj.value];
          this.execProgram(this.arrProgramsValues);
        //  this.execProgram(this.model.ProgramId);
        } else {
          const modalData: any = {};
          modalData.Title = this.translate.instant('Common_lblOops').toString();
          modalData.Message = this.translate.instant('Message_errorMessage').toString();
          this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(data => {
              _self.dialog.context.modalData.next = 'no';
              _self.dialog.close();
            });
          });
        }
      },
      error => {}
    );
  }
  sliderOnChange(obj) {
    const program = this.arrPrograms[obj.value];
    this.execProgram(program);
  }
  execProgram(program){
//console.log("la data que llega a exec program", program) 
      this.CurProgram = program[0];
      this.TodayProgram = this.CurProgram;
      this.model.todayRate = this.CurProgram.Rate;
      this.model.rate = this.CurProgram.Rate;
      this.model.fee = this.CurProgram.Fee;

      //console.log("super send length", program)
    if (program.length < 2) {
        // Cerrar el modal si la condición se cumple
        this.closePopup();
        return; // Opcional: salir del método si no quieres ejecutar el resto del código
    }

    this.CurProgram = program[1];
    this.model.supersendRate = this.CurProgram.Rate; 
    this.model.superSendfee = this.CurProgram.Fee;

       

      
      this.valueChangeForward();
  }
  execProgram1(program) {
    const _self = this;
    this.arrProgramsValues.filter(function(elm, i) {
      if (elm.ProgramId == program) {
        _self.value = i;
      }
    });

    if (program == 0) {
      this.CurProgram = this.arrProgramsValues.filter(function(elm) {
        return elm.ProgramId == program;
      })[0];
      this.TodayProgram = this.CurProgram;
      this.model.todayRate = this.CurProgram.Rate;
      this.model.rate = this.CurProgram.Rate;
      this.model.fee = this.CurProgram.Fee;

      this.model.supersendRate = 0;
    } else if (program != 0) {
      this.CurProgram = this.arrProgramsValues.filter(function(elm) {
        return elm.ProgramId == program;
      })[0];
      this.model.supersendRate = this.CurProgram.Rate;
      this.model.rate = this.CurProgram.Rate;
      this.model.fee = this.CurProgram.Fee;
    } else {
      this.model.supersendRate = 0;
      this.model.todayRate = 0;
      this.model.rate = 0;
      this.model.fee = 0;
    }

    this.valueChangeForward();
  }

  valueChangeForward() {
    let srcAmount = this.model.srcAmountBase ;//Number(this.currencyPipe.parse(this.model.srcAmountBase));
    // let srcAmount = parseFloat(this.model.srcAmount);
    
    srcAmount = srcAmount != null && srcAmount !== undefined && !isNaN(srcAmount) ? srcAmount : 0;
    this.model.diffinexchangeRate =  this.currencyPipe.transformEx(this.model.superSendfee -  this.model.fee, this.model.CurrencyCodeTo);
    this.model.diffAmount =   this.currencyPipe.transformEx((srcAmount *  this.model.supersendRate)-(srcAmount * this.model.rate), this.model.CurrencyCodeTo);
    this.model.srcAmount = this.currencyPipe.transformEx(srcAmount, this.model.CurrencyCodeFrom);
    this.model.destAmount =  this.currencyPipe.transformEx(this.utilityServ.destRoundOff(srcAmount * this.model.rate,this.RoundingPlaces), this.model.CurrencyCodeFrom);
    this.model.superSendAmount = this.currencyPipe.transformEx((srcAmount *  this.model.supersendRate), this.model.CurrencyCodeFrom);
    this.model.standardAmount = this.currencyPipe.transformEx((srcAmount * this.model.rate), this.model.CurrencyCodeFrom);
    this.model.fee = this.currencyPipe.transformEx(this.model.fee, this.model.CurrencyCodeFrom);
    this.model.todayRate = this.exchangeRatecurrencyPipe.transformEx(this.model.todayRate, this.model.CurrencyCodeFrom);
    this.model.supersendRate = this.exchangeRatecurrencyPipe.transformEx(this.model.supersendRate, this.model.CurrencyCodeFrom);
    
  }

  valueChangeBackward() {
    this.model.destAmount = parseFloat(this.model.destAmount).toFixed(AppSettings.fractionDigit);
    let destAmount = this.utilityServ.roundOff(this.model.destAmount);
    destAmount = destAmount != null && destAmount !== undefined && !isNaN(destAmount) ? destAmount : 0;
    const srcAmount = parseFloat((destAmount / this.model.rate).toFixed(AppSettings.fractionDigit));
    this.model.srcAmount = this.currencyPipe.transformEx(srcAmount, this.model.CurrencyCodeFrom);
    this.model.destAmount = this.currencyPipe.transformEx(destAmount, this.model.CurrencyCodeTo);
  }

  // getProgramDetails() {
  //   let reqObj: any = {};
  //   reqObj.CurrencyCodeTo = this.model.CurrencyCodeTo;
  //   const _self = this;
  //   this.utilityServ.busy = this.dbService.getProgramDetails(reqObj).subscribe(
  //     data => {
  //       if (data.StatusCode == 20001) {
  //         return false;
  //       }
  //       if (data.StatusCode == 10000) {
  //         if (data.Programs != '' && data.Programs != 0) {
  //           this.arrPrograms = data.Programs.split(',');
  //           this.max = this.arrPrograms.length - 1;
  //           this.getSuperSendDetails();
  //         } else {
  //           let modalData: any = {};
  //           modalData.Title = this.translate.instant('AddToCartSuccess_title');

  //           // this.dialog.close();
  //           modalData.Message = this.translate.instant('SuperSend_lblUnavailableSupersend');
  //           this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
  //             obj.onDestroy.subscribe(data => {
  //               _self.dialog.context.modalData.next = 'no';
  //               _self.dialog.close();
  //             });
  //           });
  //         }
  //       } else {
  //         this.dialog.close();
  //         let modalData: any = {};
  //         modalData.Title = this.translate.instant('AddToCartSuccess_title');

  //         modalData.Message = this.translate.instant('SuperSend_lblUnavailableSupersend');
  //         this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
  //           obj.onDestroy.subscribe(data => {
  //             _self.dialog.context.modalData.next = 'no';
  //             _self.dialog.close();
  //           });
  //         });
  //       }
  //     },
  //     error => {}
  //   );
  // }

  closePopup() {
    this.dialog.context.modalData.next = 'no';
    this.dialog.close();
  }

  Save() {
    const sendMoneyProgramDetail = new SendMoneyProgramDetail();
    sendMoneyProgramDetail.ProgramId = this.CurProgram.ProgramId;
    sendMoneyProgramDetail.srcAmount = this.retAmount(this.model.srcAmount);
    sendMoneyProgramDetail.FromPage = this.model.page;
    this.sendMoneyService.setSendMoneyProgramDetailData(sendMoneyProgramDetail);
    this.dialog.context.modalData.next = 'yes';
    this.dialog.close();
  }

  removeCurrency(event) {
    event.currentTarget.value = this.currencyPipe.parse(event.currentTarget.value);
    event.currentTarget.value = event.currentTarget.value.replace(/[^0-9-.]/g, '');
    event.currentTarget.value = Number(event.currentTarget.value) == 0 ? '' : event.currentTarget.value;
  }
  addCurrency(event, cur) {
    event.currentTarget.value = event.currentTarget.value == '' ? 0 : event.currentTarget.value;
    event.currentTarget.value = this.currencyPipe.transformEx(event.currentTarget.value, cur);
  }
  retAmount(amount) {
    const val = amount.replace(/[^0-9-.]/g, '');
    return parseFloat(Number(val).toFixed(AppSettings.fractionDigit));
  }

}



// WEBPACK FOOTER //
// ./src/app/dash-board/dashboard-supersend/dashboard-supersend.component.ts